// actions are commited
import {FETCH_SUPPORT_USERS, GET_SUPPORT_USERS} from '../actions/types';

const initialState = {
    loading:true,
    supportUsers: [{
        tabsallowed:""
    }]
};

export default function (state = initialState, action) {
    switch (action.type) {

        case FETCH_SUPPORT_USERS :
            return {
                ...state,
                supportUsers: action.payload, loading:false
            };

        case GET_SUPPORT_USERS :
            return {
                ...state
            };

        default :
            return state;
    }
}